import { ReactComponent as BucketIcon } from '../../icons/bucket.svg';
import { useTranslation } from 'react-i18next';
import './ManualUploadFile.scss';
import { FileIconsMap } from './ManualUploadFileLink';
import MiniLoader from '../MiniLoader/MiniLoader';
import Button from '../Button';

interface Props {
  onDeleteFile: () => void;
  file: File;
  className?: string;
  disabled: boolean;
  isUploading?: boolean;
}

export default function ManualUploadFile({
  onDeleteFile,
  file,
  disabled,
  className = '',
  isUploading,
}: Props) {
  const { t } = useTranslation();

  const name = file.name
    .split('.')
    .map((v, i, self) => {
      if (i === self.length - 2) {
        return v.replace(/_\d+$/, '..');
      }
      return v;
    })
    .join('.');

  return (
    <div
      className={`ManualUploadFile d-flex align-items-start w-100 justify-content-between ${className}`}
    >
      <div className='d-flex ManualUploadFile__info'>
        <span className='ManualUploadFile__icon me-2 rounded-circle'>
          {
            FileIconsMap[
              (file.name.split('.').slice(-1)[0] as string).toLowerCase()
            ]
          }
        </span>
        <div>
          <div className='ManualUploadFileLink__name fw-600'>{name}</div>
          <div className='Text--sm Text--gray'>{t('file not sent')}</div>
        </div>
      </div>
      <div
        className='d-flex align-items-center'
        style={{
          paddingTop: 6,
        }}
      >
        {isUploading ? (
          <div
            style={{
              width: 24,
              height: 24,
            }}
            className='d-flex'
          >
            <MiniLoader className='MiniLoader--sm d-flex align-items-center justify-content-center MiniLoader--gray m-auto' />
          </div>
        ) : (
          <Button
            styling='naked'
            className='ManualUploadFile__btn'
            onClick={onDeleteFile}
            disabled={disabled}
            type='button'
          >
            <BucketIcon />
          </Button>
        )}
      </div>
    </div>
  );
}
